export const appName = "evir-web-app";
export const appVersion = "2.1.2";
